type PaymentIntegrationInitializationTrigger = 'payment-tab' | 'gateway-select' | 'submit';

type PaymentIntegrationInitializer = {
	name: string;
	initialize: (reason: PaymentIntegrationInitializationTrigger) => Promise<void> | void;
};

type PaymentIntegrationReadiness = {
	ensure(reason: PaymentIntegrationInitializationTrigger): Promise<void>;
};

let activePaymentIntegrationInitialization: PaymentIntegrationReadiness | null = null;

function createPaymentIntegrationReadiness(initializers: PaymentIntegrationInitializer[]): PaymentIntegrationReadiness {
	let initializationPromise: Promise<void> | null = null;

	return {
		async ensure(reason: PaymentIntegrationInitializationTrigger): Promise<void> {
			if (initializationPromise) {
				await initializationPromise;
				return;
			}

			initializationPromise = Promise.allSettled(initializers.map(async initializer => initializer.initialize(reason)))
				.then(results => {
					results.forEach((result, index) => {
						if (result.status === 'fulfilled') {
							return;
						}

						console.error(`Failed to initialize payment integration: ${initializers[index]?.name ?? 'unknown'}`, result.reason);
					});
				});

			await initializationPromise;
		},
	};
}

function registerPaymentIntegrationReadiness(readiness: PaymentIntegrationReadiness): void {
	activePaymentIntegrationInitialization = readiness;
}

async function ensurePaymentIntegrationsReady(reason: PaymentIntegrationInitializationTrigger): Promise<void> {
	await activePaymentIntegrationInitialization?.ensure(reason);
}

function startPaymentIntegrationInitialization(reason: PaymentIntegrationInitializationTrigger): void {
	void ensurePaymentIntegrationsReady(reason).catch(error => {
		console.error('Failed to initialize payment integrations', error);
	});
}

export {
	type PaymentIntegrationInitializer,
	type PaymentIntegrationReadiness,
	type PaymentIntegrationInitializationTrigger,
	createPaymentIntegrationReadiness,
	ensurePaymentIntegrationsReady,
	registerPaymentIntegrationReadiness,
	startPaymentIntegrationInitialization,
};
